import { createAsyncThunk } from '@reduxjs/toolkit'

import { AppEnv } from 'meta/app'
import { AppController } from 'controller/app'
import { HttpRequest, HttpRequestForApiV4 } from 'utils/http'

export const init = createAsyncThunk<{ env: AppEnv }, void>('app/init', async () => {
  const env = await AppController.getEnv()

  HttpRequest.initBaseUrl(env.BACKEND_API_V1_BASE)
  HttpRequestForApiV4.initBaseUrl(env.BACKEND_API_V4_BASE)

  return { env }
})
